import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { updateUserProfile } from '../babyBookService';

const isNative = Capacitor.isNativePlatform();

/**
 * Register for push notifications and store the FCM token in Firestore.
 * Call this after the user authenticates.
 * Only runs on native (iOS/Android) — no-ops on web.
 */
export const registerPushNotifications = async (userId) => {
  if (!isNative || !userId) return;

  try {
    // Check current permission status
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      console.log('Push notification permission not granted');
      return;
    }

    // Register with APNs/FCM
    await PushNotifications.register();

    // Listen for registration success — store the token
    PushNotifications.addListener('registration', async (token) => {
      console.log('Push registration token:', token.value);
      try {
        await updateUserProfile(userId, {
          fcmToken: token.value,
          fcmTokenUpdatedAt: new Date().toISOString(),
          fcmPlatform: Capacitor.getPlatform() // 'ios' or 'android'
        });
        console.log('FCM token saved to Firestore');
      } catch (err) {
        console.error('Failed to save FCM token:', err);
      }
    });

    // Listen for registration errors
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error:', error);
    });

    // Handle notifications received while app is in foreground
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Push notification received in foreground:', notification);
      // Could show an in-app toast/banner here if desired
    });

    // Handle notification tap (app was in background or closed)
    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('Push notification tapped:', notification);
      // Could navigate to the relevant book here if desired
    });

  } catch (error) {
    console.error('Push notification setup error:', error);
  }
};

/**
 * Remove push notification listeners (call on logout)
 */
export const unregisterPushNotifications = async (userId) => {
  if (!isNative) return;

  try {
    await PushNotifications.removeAllListeners();
    // Clear the token from Firestore so they stop getting notifications
    if (userId) {
      await updateUserProfile(userId, {
        fcmToken: null,
        fcmTokenUpdatedAt: new Date().toISOString()
      });
    }
  } catch (error) {
    console.error('Push notification cleanup error:', error);
  }
};
